module.exports = __webpack_public_path__ + "img/torolab-logo.e8354b77.svg";